import * as yup from 'yup'

const passwordResetValidators = yup.object({
  password: yup
    .string()
    .matches(/[A-Z]/, 'Must have an Upper Case Letter')
    .matches(/[a-z]/, 'Must have a Lower Case Letter')
    .matches(/\d/, 'Must have a Number')
    .matches(/\W/, 'Must have a Special Character')
    .min(8, 'Must be at least 8 characters')
    .required(),
  confirmPassword: yup
    .string()
    .when('password', (p1: string, schema: yup.AnySchema) => schema.test({
      test: (p2: string) => p1 === p2,
      message: 'Passwords do not match',
    }))
    .required(),
})

export default passwordResetValidators
